<template>
    <div class="components-renzhi-history">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="period" label="时间" width="220px"></el-table-column>
            <el-table-column prop="trainingName" label="培训名称"></el-table-column>
            <el-table-column prop="orgDepartment" label="培训组织部门"></el-table-column>
            <el-table-column prop="trainingPlace" label="培训地点"></el-table-column>
            <el-table-column prop="absenceType" label="缺勤类型"></el-table-column>
            <el-table-column prop="courseHours" label="课时"></el-table-column>
            <el-table-column prop="checkResult" label="考核成绩/评分"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        username: {
            type: String,
            require: true,
        },
    },
    data() {
        return {
            get_data_api: "/user/personalCenter/trainingInfo",
            tableData: [],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.$axios.get(this.get_data_api, { username: this.username }).then((res) => {
                this.tableData = res.body || [];
            });
        },
    },
};
</script>

<style scoped></style>
